import '../App.css';
import '../scss/App.scss';
import { Box, Container, Grid, Link, Button, TextField, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, } from '@mui/material';
import { useEffect, useState, useRef } from 'react';
import axios from 'axios'; // If you're using axios
import { useParams } from 'react-router-dom';
import { Typography } from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';

const tracks = [
  {
    id: 0,
    title: 'Old Track',
    img: '../assets/treks/old-trek.jpeg',
  },
  {
    id: 1,
    title: 'New Track',
    img: '../assets/treks/new-trek.jpeg',
  },
  {
    id: 2,
    title: 'Helicopter Route',
    img: '../assets/treks/helicopter-route.jpg',
  },
];
function AyodhyaTemple({ onSave }) {

  const [templeData, setTempleData] = useState(null);
  const [weather, setWeather] = useState([]);
  const [timing, setTiming] = useState([]);
  const [aarti, setAarti] = useState([]);
  const [route, setRoute] = useState([]);
  const [peakMonth, setPeakMonth] = useState([]);
  const [offPeakMonth, setOffPeakMonth] = useState([]);
  const [accommodation, setAccommodation] = useState([]);
  const [sections, setSections] = useState([]);
  const [yatraParchi, setYatraParchi] = useState([]);
  const [yatraParchiTitle, setYatraParchiTitle] = useState('');
  const [yatraParchiSubtitle, setYatraParchiSubtitle] = useState('');

  const { id } = useParams();







  
  const weatherImg = [
    {
      image: "../assets/march-june.svg",
    },
    {
      image: "../assets/july-sept.svg",
    },
    {
      image: "../assets/oct-nov.svg",
    },
    {
      image: "../assets/dec-feb.svg",
    },
  ];
  const initialDescription = 'Demo text goes here.';
  const [description, setDescription] = useState(initialDescription);
  const [isEditing, setIsEditing] = useState(false);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveClick = () => {
    setIsEditing(false);
    if (onSave) {
      onSave(description); // Optionally update to API or parent state
    }
  };

  useEffect(() => {
    if (templeData?.sections?.[0]?.description) {
      setDescription(templeData.sections[0].description);
    }
  }, [templeData]);

  const mergedWeather = weather.map((item, index) => ({
    ...item,
    image: weatherImg[index]?.image || "/assets/default-placeholder.svg",
  }));

  const [openModal, setOpenModal] = useState(false);
  const [modalContent, setModalContent] = useState('');

  const getTruncatedText = (text, wordLimit = 24) => {
    const words = text.split(' ');
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(' ') + '...';
  };

  const handleReadMore = (fullText) => {
    setModalContent(fullText);
    setOpenModal(true);
  };
  return (
    <>
      <Box className="innerbanner" >
        <img src="../assets/banner/ayodhya-image.svg" alt="" />
        <Box className="innerContent">
          <h1>Shri Ram Mandir, Ayodhya </h1>
        </Box>
      </Box>
      <Box className="templeDetailBox">
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center" >
            <Grid size={{ xl: 8, lg: 8, md: 8, sm: 12, xs: 12 }} >
              <Box
                className="detailBoxContent"
                sx={{

                  position: 'relative',
                }}
              >
                <p className='mb-1'>In the sacred city of Ayodhya, where the Sarayu River flows gently and faith runs deep, rises the magnificent Shri Ram Mandir—a long-awaited symbol of devotion, justice, and cultural pride. Dedicated to Lord Shri Ram, the seventh incarnation of Vishnu and the eternal embodiment of dharma and righteousness, this grand temple stands as a beacon of spiritual and cultural heritage.</p>

<p>Constructed at the very site believed to be Bhagwan Ram’s birthplace, the temple is more than an architectural marvel—it is the culmination of centuries of unwavering faith and collective emotion. Every pillar and every intricate carving narrates the timeless tales of the Ramayana, echoing the ideals of sacrifice, loyalty, and divine strength.

</p>
              </Box>
            </Grid>
            <Grid size={{ xl: 4, lg: 4, md: 4, sm: 12, xs: 12 }} >
              <Box className="detailBoxImg">
                <img src="../assets/ram-image.svg" alt="" className='img-fluid' />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <section>
        <Box className="tempratureBox">
          <Container maxWidth="md">
            <Grid container spacing={2} alignItems="center" justifyContent="center">
              <Grid size={12}>
                <Box className="templeInnerHeading">
                  <h2>Monthly Temperature Guide</h2>
                </Box>
              </Grid>

              <Grid size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 6 }}>
                <Box className="tempratureContentBox">
                  <img src="../assets/march-june.svg" alt="" className="w-100" />
                  <h3>  
                     Summer
                    <br />
                    <span>28°C to 35°C</span>
                  </h3>
                </Box>
              </Grid>

                <Grid size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 6 }}>
                <Box className="tempratureContentBox">
                  <img src="../assets/dec-feb.svg" alt="" className="w-100" />
                  <h3>
                    Winter
                    <br />
                    <span>15°C to 25°C</span>
                  </h3>
                </Box>
              </Grid>  

            </Grid>
          </Container>
        </Box>
      </section>
      <section>
        <Box className="tampleTimingBox">
          <Container maxWidth="md">
            <Grid container spacing={2} alignItems="stretch">
              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
                <Box className="tampleTimingImg">
                  <img src="../assets/ram-timing.svg" className='img-fluid' alt="" />
                </Box>
              </Grid>
              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
                <Box className="tampleTimingContent grayBox p-lg-4">
                  <Box className="templeInnerHeading">
                    <h3>Temple Timings</h3>
                  </Box>
                  <ul>
                    <li>
                      Opening Hours
                      <span>6:30 AM to 9:30 PM</span>
                    </li>
                  </ul>

                  <Box className="templeInnerHeading mt-3">
                    <h3>Aarti Schedule</h3>
                  </Box>
                  <ul>
                    <li>
                      Mangala Aarti
                      <span>4:30 AM</span>
                    </li>
                    <li>
                      Shringar Aarti
                      <span>6:30 – 7:00 AM</span>
                    </li>
                    <li>
                      Bhog Aarti
                      <span>12:00 PM</span>
                    </li>
                    <li>
                      Madhyanha Aarti
                      <span>2:30 PM</span>
                    </li>
                  </ul>
                </Box>
              </Grid>
            </Grid>
            
           
          </Container>
        </Box>
      </section>
  
         <section className="lightGrayBox">
                <Container maxWidth="md">
              <Grid container spacing={2} alignItems="center" className="mt-4" justifyContent="center">
                <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                  <Box className="templeInnerHeading">
                    <h2>Plan Your Route</h2>
                  </Box>
                </Grid>


                
                  <Grid size={{ xl: 12, lg: 12, md: 12, sm: 6, xs: 12 }} >
                    <Box className="routeBox">
                     

                      <Box className="routeInnerBox">
                        <Box className="route1">
                          <img src="../assets/route-icon/flight.svg" alt="" className='img-fluid' />
                          <h3>Flight</h3>
                        </Box>
                        <Box className="route2">
                          <img src="../assets/route-icon/border.svg" alt="" className='img-fluid' />
                        </Box>
                        <Box className="route3">
                          <p>Faizabad Airport, Ayodhya (Approx. 10 km)</p>
                        </Box>
                      </Box>

                       <Box className="routeInnerBox">
                        <Box className="route1">
                          <img src="../assets/route-icon/train.svg" alt="" className='img-fluid' />
                          <h3>Train</h3>
                        </Box>
                        <Box className="route2">
                          <img src="../assets/route-icon/border.svg" alt="" className='img-fluid' />
                        </Box>
                        <Box className="route3">
                          <p>Ayodhya Railway Station (2 km)</p>
                        </Box>
                      </Box>

                      <Box className="routeInnerBox">
                        <Box className="route1">
                          <img src="../assets/route-icon/bus.svg" alt="" className='img-fluid' />
                          <h3>Bus</h3>
                        </Box>
                        <Box className="route2">
                          <img src="../assets/route-icon/border.svg" alt="" className='img-fluid' />
                        </Box>
                        <Box className="route3">
                          <p>Ayodhya Bus Stand (0.5 km)</p>
                        </Box>
                      </Box>

                      <Box className="routeInnerBox">
                        <Box className="route1">
                          <img src="../assets/route-icon/texi.svg" alt="" className='img-fluid' />
                          <h3>Private Taxi</h3>
                        </Box>
                        <Box className="route2">
                          <img src="../assets/route-icon/border.svg" alt="" className='img-fluid' />
                        </Box>
                        <Box className="route3">
                          <p>Ola available</p>
                        </Box>
                      </Box>

                      

                      
                    </Box>
                  </Grid>
                


              </Grid>
              </Container>
            </section>

      <section>
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="templeInnerHeading">
                <h2>Best Time to Visit Peak Seasons Festivals <br />like Ram Navami and Diwali</h2>
              </Box>


            </Grid>
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="templeInnerHeading mb-4">
                <h3 className='heighLightText'>Peak and <span>Off-Season</span></h3>
                <p>(visitors/Daily)</p>
              </Box>
            </Grid>
            
              <Grid size={{ xl: 2.4, lg: 2.4, md: 2.4, sm: 6, xs: 6 }} >
                <Box className="peakMonthBox">
                  <Box>
                    <span>300,000  </span>
                  </Box>
                </Box>
              </Grid>

             

              <Grid size={{ xl: 2.4, lg: 2.4, md: 2.4, sm: 6, xs: 6 }} >
                <Box className="offPeakMonthBox">
                  <Box>
                    <span>100,000</span>
                  </Box>
                </Box>
              </Grid>

             
            

        
          </Grid>
        </Container>
      </section>


      <Box className="lightGrayBox">
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="templeInnerHeading mb-lg-4">
                <h2>Accommodation Information</h2>
              </Box>
            </Grid>
            
              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                <Box className="accommodationBox">
                  <Box className="accommodationImg">
                    <img src="/assets/accommodation-icon/icon1.svg" className='img-fluid' alt="" />
                  </Box>
                  <Box className="accommodationContent">
                    <h3>Hotels</h3>
                    <p className='mb-0'>Hotel Ram Mandir Palace (0.5 km)</p>
                    <p>Hotel Ayodhya Heights (1 km)</p>
                  </Box>
                </Box>
              </Grid>

              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                <Box className="accommodationBox">
                  <Box className="accommodationImg">
                    <img src="/assets/accommodation-icon/icon1.svg" className='img-fluid' alt="" />
                  </Box>
                  <Box className="accommodationContent">
                    <h3>Dharamshalas/Dormitories</h3>
                    <p className='mb-0'>Ram Mandir Dharamshala (0.6 km)</p>
                    <p>Ayodhya Dormitory (1 km)</p>
                  </Box>
                </Box>
              </Grid>


              
            

          </Grid>
        </Container>
      </Box>

     <section>
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center" alignItems="stretch">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="templeInnerHeading mb-lg-4">
                <h2>Here’s What You Should Know</h2>
              </Box>
            </Grid>
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 3, lg: 3, md: 3, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>

                      <h2>01</h2>
                      <h3>Dress Code</h3>

                    </div>
                  </Grid>

                  <Grid size={{ xl: 9, lg: 9, md: 9, sm: 12, xs: 12 }} >
                    <div className='infoList'>
                      <ul>
                        <li><span>Men:</span> Shirt & Trouser, Dhoti, or Pyjamas with upper cloth</li>
                        <li><span>Women:</span> Saree or Half-saree with blouse</li>
                      </ul>
                    </div>
                  </Grid>
                </Grid>
              </div>



            </Grid>


          



            <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>

                      <h2>02</h2>
                      <h3>Photography / Videography</h3>

                    </div>
                  </Grid>

                  <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }} >
                    <div className='infoList'>

                      <p>Not Allowed</p>
                    </div>
                  </Grid>
                </Grid>
              </div>



            </Grid>


            <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>

                      <h2>03</h2>
                      <h3>Wheelchair Access</h3>

                    </div>
                  </Grid>

                  <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }} >
                    <div className='infoList'>

                      <p>Not Available</p>
                    </div>
                  </Grid>
                </Grid>
              </div>



            </Grid>
              

              <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 3, lg: 3, md: 3, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>

                      <h2>04</h2>
                      <h3>Parking</h3>

                    </div>
                  </Grid>

                  <Grid size={{ xl: 9, lg: 9, md: 9, sm: 12, xs: 12 }} >
                    <div className='infoList'>
                      <ul>
                        <li>Ram Mandir Parking located opposite the Janmabhoomi and Hanuman Garhi entrances</li>
                      </ul>
                    </div>
                  </Grid>
                </Grid>
              </div>



            </Grid>
            
            


             <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 3, lg: 3, md: 3, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>

                      <h2>05</h2>
                      <h3>Guided Tours</h3>

                    </div>
                  </Grid>

                  <Grid size={{ xl: 9, lg: 9, md: 9, sm: 12, xs: 12 }} >
                    <div className='infoList'>
                      <ul>
                        <li>Not Available</li>
                      </ul>
                    </div>
                  </Grid>
                </Grid>
              </div>



            </Grid>


            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 3, lg: 3, md: 3, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>

                      <h2>06</h2>
                      <h3>Shoe Locker Stand</h3>

                    </div>
                  </Grid>

                  <Grid size={{ xl: 9, lg: 9, md: 9, sm: 12, xs: 12 }} >
                    <div className='infoList'>
                      <ul>
                        <li>Free locker Service Inside complex / free shoe stand</li>
                      </ul>
                    </div>
                  </Grid>
                </Grid>
              </div>



            </Grid>

          


          
          
          </Grid>
        </Container>
      </section>


      <section className="lightGrayBox">
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="templeInnerHeading mb-lg-4">
                <h2>Explore Nearby</h2>
              </Box>
            </Grid>
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="explore-nearby">
                <Grid container spacing={2}>
                  {/* Left Column */}
                  <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }}>
                    <Box className="info-box">
                      <Typography className="title">Tourist Attractions</Typography>
                      <div className="block">
                        <p>1. Hanuman Garhi Mandir</p>
                        <p>2. Kanak Bhavan Temple</p>
                        <p>3. Saryu Ghat</p>
                        <p>4. Nageshwarnath Temple</p>
                      </div>
                    </Box>

                    <Box className="info-box mt-3">
                      <Typography className="title">ATMs & Banks</Typography>
                      <p>State Bank of India (0.2 km)</p>
                      <p>Axis Bank (0.5 km)</p>
                    </Box>

                    <Box className="info-box mt-3">
                      <Typography className="title">Boating Available in Ayodhya Saryu River</Typography>
                      <p><span>1.</span> The Jatayu Cruise is a Ramayana-themed 18 km journey from Naya Ghat to Guptar Ghat, priced at ₹300 per person.</p>
                      <p><span>2.</span> At Saryu Ghat, boat rides start at ₹150 for long trips and ₹60 for shorter ones, with group and solo options offering scenic, peaceful river views.</p>
                    </Box>
                  </Grid>

                  {/* Right Column */}
                  <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }}>
                    <Grid container spacing={2}>
                      <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                        <Box className="info-box">
                          <Typography className="title">Hospitals</Typography>
                          <p>Ayodhya Medical College and Hospital (0.5 km) Civil Hospital (1.5 km)</p>
                          <p><br /></p>
                        </Box>
                      </Grid>
                      <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                        <Box className="info-box">
                          <Typography className="title">Pharmacies</Typography>
                          <p>CareZone Pharmacy (0.4 km)</p>
                          <p>Wellness Pharmacy (0.6 km)</p>
                        </Box>
                      </Grid>

                      <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                        <Box className="info-box">
                          <Typography className="title">Food Options</Typography>
                          <p>Ram Mandir Dining (0.5 km)</p>
                          <p>Ayodhya Kitchen (1 km)</p>
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>


                  

                </Grid>
              </Box>
            </Grid>

          </Grid>
        </Container>
      </section>


      
    

    


    </>
  );
}
export default AyodhyaTemple;